import VConsole from 'vconsole'

import {
    onBroadcast,
    onBroadcastCustom,
    onWebviewshow,
    RewardJsInstall,
    RewardJsToggleCloseBtnShow,
    VideoBridgeGetFileInfo,
    VideoBridgeInit,
    VideoBridgeToggleBouncesOff
} from "../../api";
import {_device} from "../../common/m_base/util";
import {
    appendSubView,
    bringViewToFront,
    hideView,
    setViewAlpha,
    setViewScale,
    showView
} from "../../api/nativeComponent/compVisibleCommon";
import {createWebview, webviewLoad} from "../../api/nativeComponent/compWebview";
import {getCreatedInstanceId} from "../../api/apiUtil";
import {closeAd} from "../../api/nativeComponent/compCommon";
// import {onClicked} from "../../api/nativeComponentListener";

export default class Tpl {

    constructor(props) {
        this.childTplList = []

        let MTG_SDKContext = window.MTG_SDKContext
        if (MTG_SDKContext && MTG_SDKContext.unitId && MTG_SDKContext.unitSetting && MTG_SDKContext.sdkSetting) {
            this.unitId = MTG_SDKContext.unitId
            this.unitSetting = MTG_SDKContext.unitSetting
            this.sdkSetting = MTG_SDKContext.sdkSetting
        } else {
            console.warn('当前实例初始化失败, 缺少 MTG_SDKContext')
        }

        onBroadcast({
            cb: res => {
                console.warn('[Global]收到广播: ', res)
            }
        })
    }

    /**
     * 初始化
     * @return
     */
    init({JsBridgeRes}) {

        // 针对 Promise 添加调试监听
        window.addEventListener("unhandledrejection", event => {
            console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, {event});
        });

        // iOS 下禁用滑动反弹
        if (_device().isiOS) {
            VideoBridgeToggleBouncesOff()
        }

        this.bindEvent()
    }

    show(res) {
        console.log('----------webviewshow triggered.')
        // this.initCloseButton(res)
        console.log('----------initCloseButton done.')
        // this.showVideo(res)
        // this.playVideo(res)
    }

    /**
     * 获取并初始化 SDK 的上下文
     * @returns {Promise<boolean|{appSetting: *, bigTemplateInstanceId: *, campaignList: *, sdkSetting: *, unitSetting: *, sdk_info: *, unit_id: *, device: *}>}
     */
    async initSDKContext() {
        const VideoBridgeRes = await VideoBridgeInit().catch(error => console.warn(error))

        if (typeof VideoBridgeRes === 'undefined') {
            console.warn('VideoBridge init 获取 SDK 上下文失败, VideoBridgeRes: ', VideoBridgeRes)
            return false
        }

        const unitId = VideoBridgeRes.unit_id
        const sdkInfo = VideoBridgeRes.sdk_info
        const {campaignList, appSetting, unitSetting, rewardSetting, sdkSetting, device} = VideoBridgeRes

        // 获取大模板的 cmptId
        const selfViewInstanceId = sdkSetting && sdkSetting.instanceId
        const rootViewInstanceId = sdkSetting && sdkSetting.rootViewInstanceId
        const playVideoMute = sdkSetting && sdkSetting.playVideoMute

        // 构建 "全局" 的上下文环境对象
        this.MTG_SDKContext = {
            campaignList,
            sdkInfo,
            unitId,
            appSetting,
            unitSetting,
            rewardSetting,
            sdkSetting,
            device,
            selfViewInstanceId,
            bigTemplateInstanceId: selfViewInstanceId,
            rootViewInstanceId,
            playVideoMute,
        }
        window.MTG_SDKContext = this.MTG_SDKContext

        // 将数据填充到 "当前实例" 的上下文中
        this.campaignList = campaignList
        this.sdkInfo = sdkInfo
        this.unitId = unitId
        this.appSetting = appSetting
        this.unitSetting = unitSetting
        this.rewardSetting = rewardSetting
        this.sdkSetting = sdkSetting
        this.device = device
        this.selfViewInstanceId = selfViewInstanceId
        this.bigTemplateInstanceId = selfViewInstanceId
        this.rootViewInstanceId = rootViewInstanceId
        this.playVideoMute = playVideoMute

        return this.MTG_SDKContext
    }

    /**
     * 绑定事件
     * @return
     */
    bindEvent() {
        this.bindPageEvent()
        this.bindNativeEvent()
    }

    bindPageEvent() {
        console.log('Tpl.js: bindPageEvent()')
    }

    bindNativeEvent() {
        console.log('onBroadcastCustom 监听中...')
        onBroadcastCustom({
            cb: res => {
                console.log(res)
            }
        })
    }

    /**
     * 安装
     * @param campaign
     */
    install(campaign) {
        console.log('触发安装: RewardJsInstall', {campaign})
        RewardJsInstall(campaign)
    }

    async showCtaBanner() {
        let unitId = this.unitId
        let rect = {left: 180, top: 400, right: 10, bottom: 200, width: 200, height: 400}

        if (typeof this.ctaBannerId !== 'string') {
            let title = 'cta banner'
            let bodyHtml = `
            <img src="https://cn.bing.com/th?id=OHR.WhiteLeviathan_ZH-CN0294518235_UHD.jpg&pid=hp&w=3840&h=2160&rs=1&c=4&r=0" style="max-width: 100%" alt="">
            <div id="closeMini" class="btn">关闭 cta banner</div>
            <div id="ctaBanner" class="btn">点击安装</div>
            <div id="log"></div>
            <style>.btn {margin: 5px;width: 100px;height: 100px; background: cyan; color: #fff;font-size: 16px;}</style>
            <script src="http://47.95.208.135/mtg-h5-test-case-demo/dist/m.bundle.js?t=${Date.now()}"></script>
            <script>
            let ctaBanner = document.getElementById('ctaBanner');
            ctaBanner.addEventListener('click', ev => {
                ctaBanner.style.fontSize = '36px'
                ctaBanner.style.color = 'yellow'
                try{
                    // TODO: about:blank 导致 localStorage 无法使用的问题
                    // localStorage.setItem('campaign', '{}')
                    // let campaign = JSON.parse(localStorage.getItem('campaign'))
                    WindVane.call('VideoBridge', 'broadcast', {"eventName": "broadcastctabannerinstall", data: {campaign:{id:123456,title:'测试数据'}}}, function(res){
                        console.warn(res)
                    }, function (e) {
                        console.error(res)
                    })
                    
                    // 利用 install 的 click_url 进行跳转
                    // iOS
                    WindVane.call('RewardJs', 'install', {
                        click_url: "http://www.baidu.com",
                        link_type: 4,
                        click_mode: 6,
                        notice_url: '',
                    }, function(res) {
                        console.log('RewardJs - install - success', res)
                    }, function (e) {
                        console.error('RewardJs - install - error', e)
                    })
                    // 安卓
                    /*WindVane.call('RewardJs', 'install', {
                        click_url: "http://www.baidu.com",
                        link_type: 9,
                        click_mode: 6,
                        notice_url: '',
                    }, function(res){
                        console.log('RewardJs - install - success', res)
                    }, function (e) {
                        console.error('RewardJs - install - error', e)
                    })*/
                } catch (e) {
                  let logItem = document.createElement('div')
                  logItem.textContent = '发生错误: ' + JSON.stringify(e)
                  document.querySelector('#log').appendChild(logItem)
                }
            })
            
            // TODO 如何关闭正确的 miniendcard 的实现成本较高, 这里暂不实现
            //  需要先发一个广播带上自己的 id, 然后由自己的父组件确认并接受处理这条广播
            let closeMini = document.getElementById('closeMini');
            closeMini.addEventListener('click', ev => {
                WindVane.call('VideoBridge', 'broadcast', {"eventName": "broadcastctabannerclosemini", data: {}}, function(res){
                    console.warn(res)
                }, function (e) {
                    console.error(res)
                })
            })
            </script>
            `
            let html = this.createHtmlView({title, bodyHtml})
            let preload = 2
            this.ctaBannerId = getCreatedInstanceId(await this.createWebview())
            await this.preload({id: this.ctaBannerId, html, preload, rect})
        }

        let id = this.ctaBannerId
        setTimeout(()=>{
            console.warn('delay 1 秒后 append cta banner')
            this.append({parentCmptId: MTG_SDKContext.rootViewInstanceId, childCmptId: id})
        }, 1000)
    }

    hideCtaBanner() {
        let unitId = this.unitId
        let id = this.ctaBannerId
        hideView({unitId, id})
    }

    createHtmlView({title, bodyHtml}) {
        return `<!doctype html>
        <html lang="en">
        <head>
        <meta charset="UTF-8">
                     <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
                                 <meta http-equiv="X-UA-Compatible" content="ie=edge">
                     <title>${title}</title>
        </head>
        <body>
            ${bodyHtml}
        </body>
        </html>`
    }

    createWebview({fileURL, filePath, html, rect} = {}) {
        let unitId = this.unitId
        return createWebview({unitId, fileURL, filePath, html, rect})
    }

    preload({id, fileURL, filePath, html, campaigns, unitSetting, rect}) {
        let unitId = this.unitId
        let preload = 2 // 1 标识非预加载, 2 标识预加载, ios 默认为 1, android 默认就是 preload, 所以这里需要设置为 2
        return webviewLoad({unitId, id, fileURL, filePath, html, campaigns, unitSetting, preload, rect})
    }

    append({parentCmptId, childCmptId, rect}) {
        let unitId = this.unitId
        return appendSubView({unitId, parentCmptId, childCmptId, rect})
    }

    appendTo(component) {

    }

    enableDebugMode() {
        window.vConsole = new VConsole()
    }

    loadVConsole() {
        let vConsoleScript = document.createElement("script")
        vConsoleScript.src = ""
        document.body.appendChild(vConsoleScript)
        vConsoleScript.onload = function () {
            new VConsole
        }
    }

    showVideo(res) {
        console.log('----------showVideo done.')
    }

    playVideo(res) {
        console.log('----------playVideo done.')
    }

    initCloseButton() {
        // 监听 webviewshow 事件, TODO: 倒计时显示关闭按钮
        onWebviewshow(res => {
            setTimeout(() => {
                RewardJsToggleCloseBtnShow()
            }, 3000)
        })
        // 监听关闭按钮点击事件
        // onClicked()
    }

    updateSDKContext(key, value) {
        if (typeof key === 'undefined') {
            console.warn('更新 SDKContext 失败, 请传入有效的 key 值')
            return false
        }

        this[key] = value
        if (this.MTG_SDKContext) {
            this.MTG_SDKContext[key] = value
        }
        return this.MTG_SDKContext
    }

    async getFilePathByRemoteUrl(url = '') {
        let filePath = url
        let unitId = this.unitId
        let resource = [{
            type: 2,
            ref: url
        }]
        let filePathConfig = await VideoBridgeGetFileInfo({unitId, resource})
        if (filePathConfig && filePathConfig.resource && filePathConfig.resource[0] && filePathConfig.resource[0][url] && filePathConfig.resource[0][url].path) {
            filePath = filePathConfig.resource[0][url].path
        } else {
            console.warn('获取 filePath 失败: ', {url, filePathConfig})
        }
        return filePath
    }

    async hideView(id) {
        let unitId = this.unitId
        await hideView({unitId, id: id || this.selfViewInstanceId})
    }

    async bringViewToFront(id) {
        let unitId = this.unitId
        await bringViewToFront({unitId, id: id || this.selfViewInstanceId})
    }

    async showView(id) {
        let unitId = this.unitId
        await showView({unitId, id: id || this.selfViewInstanceId})
    }

    async scaleView(id) {
        let unitId = this.unitId
        await setViewScale({
            unitId,
            id: id || this.selfViewInstanceId,
            vertical: .7,
            horizon: .7,
        })
    }

    async translucentView(id) {
        let unitId = this.unitId
        await setViewAlpha({
            unitId,
            id: id || this.selfViewInstanceId,
            alpha: .5
        })
    }

    closeAd() {
        let unitId = this.unitId
        return closeAd({unitId, id: this.selfViewInstanceId})
    }

    /**
     * 将创建成功的播放模板添加到子模板列表中, 并绑定对应的 campaign
     * @param campaignId 要绑定的 campaign id
     * @param tplInstanceId
     */
    addToChildTplList(campaignId, tplInstanceId) {
        this.childTplList.push({campaignId, tplInstanceId, isPageLoadFinished: false})
    }

    setChildTplWebviewCreateFailed({campaign}) {
        let currentChildTpl = this.getChildTplByCampaignId(campaign.id)
        if (currentChildTpl) {
            currentChildTpl.isPageCreateFailed = true
        } else {
            console.warn('setChildTplWebviewCreateFailed 出现问题', {currentChildTpl})
        }
    }

    setChildTplWebviewLoadFinished(campaignId) {
        let curChildTpl = this.childTplList.filter(item => item.campaignId === campaignId)
        if (curChildTpl) {
            curChildTpl.isPageLoadFinished = true
        } else {
            console.warn('设置 isPageLoadFinished 状态失败')
        }
    }

    getChildTplByCampaignId(campaignId) {
        let currentChildTpl
        if (this && this.childTplList && typeof this.childTplList.filter === 'function') {
            currentChildTpl = this.childTplList.filter(childTpl => childTpl.campaignId === campaignId)[0]
        }
        return currentChildTpl
    }

    bindChildTplInstanceByCampaignId(campaignId, tplInstanceId) {
        let currentChildTpl = this.getChildTplByCampaignId(campaignId)
        if (currentChildTpl) {
            currentChildTpl.tplInstanceId = tplInstanceId
        } else {
            console.warn('bindChildTplInstanceByCampaignId 出现问题', {currentChildTpl})
        }
    }
}